import { format } from "date-fns";
import React, { useContext, useEffect, useState } from "react";
import { CartContext } from "../../../contexts/CartContext";
import styles from './ExpressPassesComponent.module.scss';
import { ModalDeatils } from "./ModalDetails";


export function ExpressPassesComponent() {
    const {cart} = useContext(CartContext)
    const [ category, setCategory ] = useState('')
    const [ dateFrom,setDateFrom ] = useState('')
    const [ dateTo,setDateTo ] = useState('')

   useEffect(() => {
    cart.data.tickets.map(ticket => {
        if(ticket.tags.includes('hotels')){
            setCategory(ticket.data.category!)
            setDateFrom(ticket.attributes['5'][0])
            setDateTo(ticket.attributes['42'][0])
        }
    })
   },[cart])


    return category === 'Premier' ? (
      <div className={styles.premierTicket}>
        <h2 className={styles.freebieHeading}>Free Express Pass included with your hotel stay:</h2>
        <div className={styles.listItemTicket}>
        <p className={styles.persuasionRibbon}>Included With Your Premier Hotel Stay</p>
        <div className={styles.inside}>
          <div className={styles.info}>
            <h3>Free Universal Express Unlimited ride access</h3>
            <p className={styles.visitDates}>
              <span>{format(new Date(dateFrom),'EEE LLL d')} - {format(new Date(dateTo),'EEE LLL d')}</span>
              <ModalDeatils trigger={ <a> View details </a>} />
            </p>
          </div>
          <p className={styles.included}>
            <span className={styles.tick}></span>
            <em>Included</em>
          </p>
          </div>
        </div>
        <h2 className={styles.freebieHeading}>Want to buy more?</h2>
      </div>
    ) : null;
}